<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="[]"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "AgentProfit",
        components: {CommonTable},
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    add: 'agentProfit:add',
                    update: 'agentProfit:update',
                    delete: 'agentProfit:delete',
                    deleteBatch: 'agentProfit:deleteBatch'
                },
                url: {
                    get: '/agentProfit/listByCondition',
                    add: '/agentProfit/add',
                    update: '/agentProfit/update',
                    delete: '/agentProfit/delete/',
                    delete_batch: '/agentProfit/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    width: '',
                }, {
                    field: 'profit',
                    label: '累计收益',
                    show: true,
                    width: ''
                }, {
                    field: 'membership',
                    label: '会员总数',
                    show: true,
                    width: ''
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '180px',
                }],
                formFields: {
                    addTitle: '添加域名',
                    updateTitle: '修改域名',
                    labelWidth: '80px',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'profit',
                        label: '累计收益',
                        type: 'input',
                        placeholder: '累计收益',
                        rules: [{
                            message: '请输入累计收益', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'membership',
                        label: '会员总数',
                        type: 'input',
                        placeholder: '会员总数',
                        rules: [{
                            message: '请输入会员总数', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
